import React from "react";
import { useMoney } from "../../hooks/useMoney";
import { useTranslationEx } from "../../hooks/useTranslationEx";

interface MusicalCardProps {
  img: string;
  name: string;
  location: string;
  price: number;
  originalPrice?: number;
  id: number | string;
}

const MusicalCard: React.FC<MusicalCardProps> = ({
  img,
  name,
  location,
  price,
  originalPrice,
  id,
}) => {
  const { formatMoney } = useMoney();
  const { t2 } = useTranslationEx();
  return (
    <div className="relative h-[17rem] overflow-hidden rounded-[0.75rem]">
      <img src={img} alt={name} className="h-full w-full object-cover" />
      <div
        className="absolute top-0 h-full w-full px-5 py-6 text-white"
        style={{
          background:
            "linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100.04%)",
        }}
      >
        <p className="mb-[0.0625rem] content-center text-[1.125rem] font-semibold leading-[1.625rem]">
          {originalPrice && originalPrice !== price && (
            <span className="mr-[0.3125rem] text-[0.875rem] font-normal leading-[1.375rem] line-through">
              {formatMoney(originalPrice)}
            </span>
          )}
          {formatMoney(price)}
        </p>
        <p className="mb-[0.0625rem] text-base font-semibold">{name}</p>
        <p className="text-base font-normal leading-[1.5rem]">{t2(location)}</p>
      </div>
    </div>
  );
};

export default MusicalCard;
